const PrivacyPolicy = () => {
    return (
        <div className="page-back d-flex justify-content-center py-5" style={{ padding: '20px', backgroundColor: '' }}>
            <div className="text-center container bg-white px-4" style={{ borderRadius: "10px", boxShadow: "0 2px 6px rgba(0,0,0,0.2)"}}>
                <h2 style={{ margin: '20px 0' }}>Privacy Policy</h2>

                <p> At 24/7 AssureCare, we value your privacy and are committed to being transparent
                about how we handle your information.
                </p>

                <h4 style={{ marginTop: '20px' }}>Contact Forms</h4>
                <p> When you submit information through our website forms, such as your name and email,
                this data is sent directly to our business email via EmailJS. We do not store
                your personal information on our website or share it with third parties. Your
                information is used solely to respond to your inquiries.
                </p>

                <h4 style={{ marginTop: '20px' }}>Website Analytics</h4>
                <p> We use Google Analytics to gather anonymous insights about website traffic and
                usage patterns. This data is aggregated and does not identify clients,
                potential business partners, or employees.
                </p>

                <h4 style={{ marginTop: '20px' }}>Employee Login System</h4>
                <p> Our login system and associated database contain information only about our
                employees. No client or partner information is stored in this system.
                </p>

                <h4 style={{ marginTop: '20px' }}>Data Security</h4>
                <p> We take reasonable measures to protect your data during transmission and
                processing. While we cannot guarantee complete security, we are committed
                to maintaining the integrity of your information.
                </p>

                <h4 style={{ marginTop: '20px' }}>Contact Us</h4>
                <p> If you have any questions or concerns about your privacy or our data practices,
                please contact us at <a href="mailto:info@247assurecare.com">info@247assurecare.com</a>.
                </p>
            </div>
        </div>
    )
}

export default PrivacyPolicy;
